<script setup lang="ts">
import type { CollectionType } from "@/common/types/collection";

import {
  TabDetailManufacturer,
  TabDetailGender,
  TabDetailRegion,
  TabDetailRelease,
  TabDetailFranchise,
  TabDetailMedia,
  TabDetailLanguage,
  TabDetailTag,
} from "@/components";

defineProps<{
  collection: CollectionType;
}>();
</script>

<template>
  <section class="tab-collection">
    <div class="content">
      <!-- Tags -->
      <tab-detail-tag :collection-id="collection.collection_id" />

      <!-- Regions -->
      <tab-detail-region :collection-id="collection.collection_id" />

      <!-- Languages -->
      <tab-detail-language :collection-id="collection.collection_id" />

      <!-- Manufacturers -->
      <tab-detail-manufacturer :collection-id="collection.collection_id" />

      <!-- medias -->
      <tab-detail-media :collection-id="collection.collection_id" />

      <!-- Releases -->
      <tab-detail-release :collection-id="collection.collection_id" />

      <!-- Franchises -->
      <tab-detail-franchise :collection-id="collection.collection_id" />

      <!-- Genders -->
      <tab-detail-gender :collection-id="collection.collection_id" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-collection {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-collection {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
